import React from "react";
import RiskMatrixEditorSteps from "./RiskMatrixEditorSteps";

export default function RiskMatrixEditor({ initialMatrix = null, onSave, existingMatrices = [] }) {
  return (
    <RiskMatrixEditorSteps 
      initialMatrix={initialMatrix} 
      onSave={onSave} 
      onCancel={() => onSave(null)} 
      existingMatrices={existingMatrices}
    />
  );
}
